import Box from './Box';
import Icon from './Icon';
import './LfaPopOver.css';
import LFA from '../images/LFA.png';
import React, { useState } from "react";

export default function LfaPopover() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div tabIndex={0} onBlur={(e: any) => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        setIsOpen(false)
      }
    }}>
      <Box alignItems='center' style={{ position: 'relative' }}>
        <Box inlineFlex onClick={() => setIsOpen(!isOpen)} cursor='pointer'>
          <Icon icon="info" size={16} color='grey' />
        </Box>
        {
          isOpen &&
          <Box className='Popover-content'>
            <img src={LFA} alt='lfa' />
          </Box>
        }
      </Box>
    </div >
  );
}
